export const queryStringBuilder = (str: Array<string>, joiner = 'ids=') => {
	// return str.join(joiner)
	let query = ''
	for (let i = 0; i < str.length; i++) {
		query += joiner + str[i] + '&'
	}
	return query
}
